import { Component, EventEmitter, OnInit, Output, ViewContainerRef } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-device-info-modal',
  templateUrl: './device-info-modal.component.html',
  styleUrls: ['./device-info-modal.component.css']
})
export class DeviceInfoModalComponent implements OnInit {

  public device;

  constructor(
    private bsModalRef: BsModalRef
  ) { }

  ngOnInit() { }


  close() {
    this.bsModalRef.hide();
  }

}

